module.exports = __webpack_public_path__ + "img/part4-4.13570711.png";